import { useContext } from 'react'

import { StepperContext } from '..'

export const useStepper = () => useContext(StepperContext)
